import React, { Component } from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

class ResearchBox extends Component {

	handleChange(e) {
		this.props.update(e.target.value );
	}

	render() {
		return (
			<form>
				<FormGroup
					controlId="formBasicDate"
					validationState={this.props.validator()}
				>
					<ControlLabel>Data Inizio</ControlLabel>
					<FormControl
						type="date"
						value={this.props.filterText}
						placeholder="Enter text"
						onChange={this.handleChange.bind(this)}
					/>
					<FormControl.Feedback />
				</FormGroup>
			</form>
		);
	}
}

export default ResearchBox;



// WEBPACK FOOTER //
// ./src/components/DateBox.js